/*

Sainapse® incorporates patented, and “patent pending”, technology.

© 2017 - 2024 Sainapse Inc. and its licensors. All rights reserved worldwide.

Sainapse Inc. and its licensors own all rights in this work, including but not limited to the source code, algorithms, text, 
flowcharts and images herein, which are protected by copyright laws in applicable jurisdictions. Any use of this work is permissible 
only with an express written license or authorization from Sainapse Inc., and only to the extent and for the purpose permitted. 
Unauthorized copying, editing, reproduction, redistribution, modification, creation of derivative works, translation, adaptation, 
customization, decompilation, reverse engineering, disassembling or hacking of this work or any part thereof, including but not limited to the source code, 
header files and libraries of the software, via any medium is strictly prohibited.

Open Source Software that is provided as part of Sainapse® is subject to and governed solely by the terms and conditions of the applicable open source license agreements, 
and their respective terms, conditions, restrictions and obligations, a copy of which will be made available to you upon request.

Proprietary and Confidential. Sainapse® and associated documentation is the property of Sainapse Inc. and considered confidential information. 
No part of it may be disclosed without the express written consent of Sainapse Inc.Please note that any infringement or violation will invite legal action, 
both civil and criminal, as appropriate, without any further notice.

*/
import React, { Component } from 'react';
import { withStyles, createTheme, ThemeProvider } from '@material-ui/core/styles'

import { Typography, IconButton, Popover, Paper, Tooltip, Button, Collapse, TextField } from '@material-ui/core'
import { ExpandMore, Done, Clear, LinkOff } from '@material-ui/icons'
import GlobalFieldList from './GlobalFieldList';
import GlobalField from './GlobalField';

const blue_theme = createTheme({
    palette: {
      primary: {
        main: "#2296f3",
      },
      secondary: {
        main: "#dc014e",
      },
    },
});

const styles = theme => ({
    badge: {
        padding: `0 ${theme.spacing.unit * 0}px`,
    }
})

class GlobalFieldSelect extends React.Component {
    state = {
        open : false,
        anchorEl : null,
        temp_field : null,
        adding_global_field : false,
        new_field_name : ""
    }

    select_box = React.createRef() 


    mapField = () => {
        console.log("IFC :: GLobal Field Select : ", this.props.group_data)
        let group_id
        if (this.props.group_data.group_id === 'singletons') {
            group_id = this.props.group_data.field
        } else {
            group_id = this.props.group_data.group_id
        }
        this.props.map_global_field(group_id, this.state.temp_field)
        this.setState({...this.state, temp_field : null})
    }

    unMapField = () => {
        let group_id
        if (this.props.group_data.group_id === 'singletons') {
            group_id = this.props.group_data.field
        } else {
            group_id = this.props.group_data.group_id
        }
        this.props.map_global_field(group_id, null)
        this.setState({...this.state, temp_field : null})
    }

    renderGlobalField = () => {
        if (this.props.global_mapped_field && this.state.temp_field === null) {
            return (
                <div ref = {this.select_box} style = {{backgroundColor : '#F0F0F0', width : '100%', height : '100%', padding : '10px', display : 'flex', flexDirection : 'row', alignItems : 'center'}}>
                    <GlobalField 
                        global_field_display_name = {this.props.global_field_display_name}
                        margin = {false}
                        variant = "elevated" 
                        global_field_data = {{
                            global_concept : this.props.global_mapped_field,
                            mapped_entity : this.props.group_data
                        }}
                        field_in_focus = {this.props.field_in_focus}
                        mapping_global_field = {this.props.mapping_global_field}
                        select_global_field = {(global_field) => null}
                    />
                    <Tooltip title = {"Unmap " + this.props.global_field_display_name +  " field"}>
                        <IconButton style = {{marginRight : '5px', marginLeft : '5px'}} size = 'small' onClick = {this.unMapField} color = 'secondary'>
                            <LinkOff fontSize = 'inherit'/>
                        </IconButton>
                    </Tooltip>
                    <IconButton style = {{marginRight : '5px', marginLeft : '5px'}} size = 'small' onClick = {this.openList}>
                        <ExpandMore fontSize = 'inherit'/>
                    </IconButton>
                </div>
            )
        } else {
            if (this.state.temp_field) {
                return (
                    <div ref = {this.select_box} style = {{backgroundColor : '#F0F0F0', width : '100%', height : '100%', padding : '10px', display : 'flex', flexDirection : 'row', alignItems : 'center'}}>
                        <GlobalField
                            global_field_display_name = {this.props.global_field_display_name}
                            margin = {false}
                            variant = "elevated" 
                            global_field_data = {this.state.temp_field}
                            field_in_focus = {this.props.field_in_focus}
                            mapping_global_field = {this.props.mapping_global_field}
                            select_global_field = {(global_field) => null}
                        />
                        <IconButton style = {{marginRight : '5px', marginLeft : '5px'}} size = 'small' onClick = {() => this.setState({...this.state, temp_field : null})}>
                            <Clear style = {{color : '#eb0000'}} fontSize = 'inherit'/>
                        </IconButton>
                        <IconButton style = {{marginRight : '5px', marginLeft : '5px'}} size = 'small' onClick = {this.mapField}>
                            <Done style = {{color : '#00a806'}} fontSize = 'inherit'/>
                        </IconButton>
                        <IconButton size = 'small' onClick = {this.openList}>
                            <ExpandMore fontSize = 'inherit'/>
                        </IconButton>
                    </div>
                )
            } else {
                return (
                    <div ref = {this.select_box} style = {{backgroundColor : '#F0F0F0', width : '100%', height : '100%', padding : '10px', display : 'flex', flexDirection : 'row', alignItems : 'center'}}>
                        <Typography style = {{flexGrow : 1}} variant = 'caption' color = 'textSecondary'><em>{"Select a " + this.props.global_field_display_name + " field to map"}</em></Typography>
                        <IconButton size = 'small' onClick = {this.openList}>
                            <ExpandMore fontSize = 'inherit'/>
                        </IconButton>
                    </div>
                )
            }
        }
    }

    openList = () => {
        this.setState({...this.state, open : true, anchorEl : this.select_box.current})
    }

    renderGlobalFieldList = () => {
        var toPX = require('to-px')
        return (
            <Popover
                id = "global_field_list"
                open={this.state.open}
                anchorEl={this.state.anchorEl}
                onClose={this.handleClose}
                anchorOrigin={{
                    vertical: 'bottom',
                    horizontal: 'left',
                }}
                transformOrigin={{
                    vertical: 'top',
                    horizontal: 'left',
                }}
                PaperProps = {{
                    square : true
                }}
            >
                <div style = {{width : '50vw', backgroundColor : '#F0F0F0', height : '500px', overflow : 'auto'}}>
                    <Paper elevation = {0} square style = {{width : '100%', height : '50px', padding : '10px', display : 'flex', flexDirection: 'row', alignItems : 'center'}}>
                        <Typography style = {{flexGrow : 1}} variant = 'subtitle2'>{"Select " + this.props.global_field_display_name +  " Field"}</Typography>
                        {/* {this.props.global_mapped_field === null ? 
                            <Button variant = 'outlined' size='small' color = 'primary'
                                onClick = {() => this.setState({...this.state.adding_global_field, adding_global_field : true})}
                            >{"Add new " + this.props.global_field_display_name +  " Field"}</Button>
                            : <Typography align = 'right' variant = 'caption' color = 'textSecondary'>Unmap the existing field to add a new field.</Typography>
                        } */}
                    </Paper>
                    <div style = {{width : '100%', paddingLeft: '5px', paddingBottom : '5px',marginTop : '5px'}}>
                        <Collapse in = {this.state.adding_global_field}>
                            <div style = {{margin : '10px', display : 'flex', flexDirection : 'row', alignItems : 'center', borderBottom : '1px solid rgba(0,0,0,0.12)'}}>
                                <Typography style = {{flexGrow : 1}} variant = 'button'>Adding new field.</Typography>
                                <IconButton size = 'small' color = 'secondary' onClick = {() => this.setState({...this.state, adding_global_field : false, new_field_name : ""})}>
                                    <Clear fontSize = 'inherit'/>
                                </IconButton>
                            </div>
                            <div style = {{padding : '10px'}}>
                                <TextField
                                    variant = 'outlined'
                                    size = 'small'
                                    fullWidth
                                    label = 'New Field Name'
                                    placeholder = 'Field Name'
                                    helperText = 'This field will be automatically mapped the selected group or singleton'
                                    onChange = {(event) => this.setState({...this.state, new_field_name : event.target.value})}
                                />
                                <Button 
                                    style = {{marginTop : '10px'}} 
                                    variant = 'outlined' 
                                    color = 'primary' 
                                    size = 'small'
                                    onClick = {this.createGlobalField}
                                >Submit</Button>
                            </div>
                        </Collapse>
                        <GlobalFieldList
                            ic_name = {this.props.ic_name}
                            version = {this.props.version}
                            global_field_display_name = {this.props.global_field_display_name}
                            width = {toPX("50vw") - 10}
                            height = {400}
                            global_fields = {this.props.global_fields}
                            field_in_focus = {this.props.field_in_focus}
                            mapping_global_field = {this.props.mapping_global_field}
                            //focus_field = {(field_object, field_type, chained_func) => this.props.focus_field(field_object, field_type, chained_func)}
                            select_global_field = {(global_field) => this.selectField(global_field)}
                            show_options = {false}
                            show_score = {false}
                            show_search = {true}
                            search_label = {"Search " + this.props.global_field_display_name + " fields"}
                        />
                    </div>
                </div>
            </Popover>
        )
    }

    createGlobalField = () => {
        this.setState({...this.state, adding_global_field: false}, () => {
            let group_id
            if (this.props.group_data.group_id === 'singletons') {
                group_id = this.props.group_data.field
            } else {
                group_id = this.props.group_data.group_id
            }
            this.props.create_global_field(group_id, this.state.new_field_name)
            this.setState({...this.state, new_field_name : "", open : false})
        })
    }

    handleClose = () => {
        this.setState({...this.state, open : false, anchorEl : null})
    }

    selectField = (global_field) => {
        this.setState({...this.state, open : false, anchorEl : null, temp_field: global_field})
    }

    render() { 
        return (
            <ThemeProvider theme = {blue_theme}>
                {this.renderGlobalField()}
                {this.state.open && this.renderGlobalFieldList()}
            </ThemeProvider>
        )
    }
}
 
export default withStyles(styles)(GlobalFieldSelect);